// Builds the email draft a visitor sends from the contact form. Nothing is
// sent by the site itself: we hand the draft to the visitor's mail client.

export function composeInquiry({ to, name, email, company, interests = [], timeline, message }) {
  const clean = (v) => (v || '').trim();
  const subject = `Project inquiry — ${clean(company) || clean(name)}`;
  const details = [
    ['Name', name],
    ['Email', email],
    ['Company', company],
    ['Interested in', interests.join(', ')],
    ['Timeline', timeline],
  ]
    .filter(([, value]) => clean(value))
    .map(([label, value]) => `${label}: ${clean(value)}`);

  const body = [
    'Hi Average Quality team,',
    '',
    clean(message),
    '',
    '—',
    ...details,
    '',
    'Sent from averagequality.com',
  ].join('\n');

  return { to, subject, body };
}

// RFC 6068: line breaks in a mailto body must be encoded as %0D%0A.
const encodeMailto = (text) => encodeURIComponent(text.replace(/\r?\n/g, '\r\n'));

export const mailtoUrl = ({ to, subject, body }) =>
  `mailto:${to}?subject=${encodeMailto(subject)}&body=${encodeMailto(body)}`;

export const gmailUrl = ({ to, subject, body }) =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}` +
  `&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const outlookUrl = ({ to, subject, body }) =>
  `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(to)}` +
  `&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
